<template>
  <div ref="whole_page" style="text-align: left;">
    <div class="w-full">
      <ul>
        <div class="limit-width_fixed-scalable">
          <li style="height: 49px;" class="mb-4">
            <vx-card class="glow-effect_dark card__no-padding limit-height_fixed float-left mr-3 bg-color">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text input-group_prepend-slot-bg">
                    <span><feather-icon class="pt-1" icon="PieChartIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <vs-button
                  ref="myRosterBtn"
                  size="large"
                  class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                  style="border-radius:0 7px 7px 0"
                  @click="viewAssessments">
                  {{($getSiteId() == 21)? "View Marked Work" : "View Assessments" }}
                </vs-button>
              </vx-input-group>
              
            </vx-card>
            <vx-card class="glow-effect_dark card__no-padding limit-height_fixed float-left mr-3 bg-color mt-4">
              <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="PieChartIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                        ref="myRosterBtn"
                        size="large"
                        class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                        style="border-radius:0 7px 7px 0"
                        @click="viewHomeWork">
                        Task Notifications
              </vs-button>
            </vx-input-group>
            </vx-card>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
export default {
  components: {
    vSelect
  },
  data() {
    return {
      
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
    viewHomeWork(){
      var self = this;
      self.$router.push({name: 'HomeworkViewer',query: self.$route.query});
    },
    viewAssessments() {
      var self = this;
      self.$router.push({
        name: "StudentClassroomAssessments",
        query: self.$route.query
      });
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
  },
  mounted() {
    var self = this;
    self.$store.dispatch("updateTheme", "dark");
  }
};
</script>
<style lang="scss">
  #categorydropdown {
    .vs__actions {
      display: contents !important;

      .open-indicator {
        margin-right: 10px !important;
      }
    }
  }
</style>
